<template>
  <BasePageContainer class="mt-8 p-4">
    <PageHeader
      has-back
      with-members>
      進路活動記録
    </PageHeader>
    <PathActivityForm
      v-if="initialized"
      ref="form"
      :user-id="userId"
      :path-activity="pathActivity"
      @submit="onSubmit" />
    <b-button
      type="button"
      variant="link-secondary"
      class="text--grey09 d-flex align-items-center p-0 mt-4"
      @click="onClickDelete">
      <span class="material-icons mr-1">
        delete
      </span>
      削除する
    </b-button>
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import PathActivityForm from '@/components/view/profile/path_activities/PathActivityForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    PathActivityForm
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      initialized: false,
      pathActivity: null,
    }
  },
  computed: {
    pathActivityId() {
      return this.$route.params.pathActivityId
    },
    userId() {
      return this.$route.params.id
    }
  },
  created() {
    this.$store.commit('startLoading')
    this.fetchPathActivity().finally(() => {
      this.initialized = true
      this.$store.commit('finishLoading')
    })
  },
  methods: {
    onSubmit(formData) {
      this.patchPathActivity(formData).then(() => {
        this.$store.commit('notify/set', {message: '進路活動記録を編集しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.$route.params.id}/profile`, { replace: true })
        })
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    },
    fetchPathActivity() {
      return this.$axios.get(`/profiles/path-activities/${this.pathActivityId}/`).then((res) => {
        this.pathActivity = res.data
      })
    },
    patchPathActivity(formData) {
      return this.$axios.patch(`/profiles/path-activities/${this.pathActivityId}/`, formData)
    },
    onClickDelete() {
      if (!window.confirm('進路活動記録を削除してもよろしいですか?')) return
      this.deletePathActivity().then(() => {
        this.$store.commit('notify/set', {message: '進路活動記録を削除しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.$route.params.id}/profile`, { replace: true })
        })
      })
    },
    deletePathActivity() {
      return this.$axios.delete(`/profiles/path-activities/${this.pathActivityId}/`)
    },
  },
}
</script>

<style>

</style>